<template>
  <div>
    <div class="flex flex-around mb10">
      <div
        class="flex-1 flex flex-center purchase-data p10"
        :class="{ mr10: i < tablist.length - 1 }"
        v-for="(v, i) in tablist"
        :key="i"
      >
        <div class="hm-icon mr10">
          <span class="hmicon" :class="v.icon"></span>
        </div>
        <div class="">
          <div class="purchase-name mt10">
            {{ v.name }}
          </div>
          <div class="mt10 flex flex-between item-center">
            <div class="purchase-val">
              {{ v.val }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <hm-content title="">
      <div class="table-panel flex flex-end">
        <el-date-picker
          v-model="searchCondition.createTimeArry"
          :default-time="['00:00:00', '23:59:59']"
          value-format="yyyy-MM-dd HH:mm:ss"
          type="datetimerange"
          align="right"
          size="small"
          class="mr10"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
        <el-button type="primary" size="small" @click="search">查询</el-button>
      </div>
      <div class="">
        <el-table
          stripe
          ref="btable"
          :data="list"
          style="width: 100%"
          id="table"
          size="small"
        >
          <el-table-column type="index" label="序号"></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="sendTitle"
            label="推送标题"
            width="250"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="triggerTime"
            label="推送时间"
          ></el-table-column>
          <!-- <el-table-column
            header-align="center"
            align="center"
            prop="visitNum"
            label="覆盖人数"
          >
          </el-table-column> -->
          <el-table-column
            header-align="center"
            align="center"
            prop="noticeNum"
            label="通知人数"
          >
          </el-table-column>
          <!-- <el-table-column
            header-align="center"
            align="center"
            prop="proportion"
            label="复购率"
          >
          </el-table-column> -->
          <el-table-column header-align="center" align="center" label="状态">
            <template slot-scope="scope">
              <div v-if="scope.row.recordStatus === 'success'">
                <span class="success">已完成</span>
                <!-- <template v-if="scope.row.isHaveErrorMsg">
                  <span
                    style="font-size: 14px"
                    class="hmicon icon-tishi1 danger ml10"
                  ></span>
                  <span class="danger"> 有失败消息</span>
                  <el-button size="small" class="blue" type="text"
                    >查看详情</el-button
                  >
                </template> -->
              </div>
              <div v-if="scope.row.recordStatus === 'errorStop'" class="danger">
                异常暂停
                <span style="font-size: 14px" class="hmicon icon-tishi1"></span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="操作"
            width="200"
          >
            <template slot-scope="scope">
              <el-button
                size="small"
                class="blue"
                type="text"
                @click="details(scope.row)"
                >数据</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
    </hm-content>
  </div>
</template>

<script>
import moment from "moment";
export default {
  components: {},
  data() {
    return {
      searchCondition: {
        createTimeArry: [
          moment().format("YYYY-MM-DD") + " 00:00:00",
          moment().format("YYYY-MM-DD") + " 23:59:59"
        ]
      },
      total: 0,
      list: [],
      pageSize: 10,
      currentPage: 1,
      tablist: [
        {
          icon: "icon-zongrenshu",
          name: "今日消息通知人数（人）",
          val: "0",
          pathName: "PhysiologicalPeople"
        },
        {
          icon: "icon-zonghuiyuanzhongzhanbi",
          name: "最近七天消息通知人数（人）",
          val: "0",
          pathName: "PhysiologicalPeople"
        },
        {
          icon: "icon-tongzhirenshu1",
          name: "息通知总人数(人）",
          val: "0",
          pathName: "MessagesReachUsers"
        }
      ]
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    this.queryList();
    this.queryRepurchasePlanExecRecordNum();
  },
  methods: {
    details(row) {
      this.$router.push({
        name: "MessagePushFailed",
        query: {
          row: JSON.stringify(row)
        }
      });
    },
    // 导出excel
    output() {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        this.isOutputing = true;

        this.queryAllList()
          .then(res => {
            let list = res;
            list.forEach(v => {});
            let tHeader = this.$refs.table.columns
              .map(o => o.label !== "序号" && o.label)
              .filter(o => o);
            let filterVal = [];
            if (list.length > 0) {
              filterVal = this.$refs.table.$children
                .map(o => o._props.prop)
                .filter(o => o);
            }

            let title =
              this.searchConditionDetails.timeStatus === "alla"
                ? "抽奖流水"
                : "兑换记录";

            let data = this.formatJson(filterVal, list);

            exportJsonToExcel(
              tHeader,
              data,
              title + new Date().toLocaleString()
            );
            this.isOutputing = false;
          })
          .catch(() => {
            this.isOutputing = false;
          });
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },
    async queryAllList() {
      const params = {
        pageSize: 99999,
        pageNo: 1
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      //   if (this.sort.order === "descending") {
      //     searchCondition.sortBy = "desc";
      //   } else if (this.sort.order === "ascending") {
      //     searchCondition.sortBy = "asc";
      //   }

      Object.assign(params, searchCondition);
      const { code, result } = await this.$store.dispatch("", params);
      if (code === "0") {
        const { records } = result;
        return records;
      }
    },
    async queryRepurchasePlanExecRecordNum() {
      const { code, result } = await this.$store.dispatch(
        "queryRepurchasePlanExecRecordNum",
        {
          planType: "ageGroup"
        }
      );
      if (code === "0") {
        this.tablist[0].val = result.todayNum;
        this.tablist[1].val = result.sevenDaysNum;
        this.tablist[2].val = result.allNum;
      }
    },
    async queryList() {
      const params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage,
        planType: "ageGroup"
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      searchCondition.queryStartTime =
        this.searchCondition.createTimeArry &&
        this.searchCondition.createTimeArry.length > 0
          ? this.searchCondition.createTimeArry[0]
          : null;
      searchCondition.queryEndTime =
        this.searchCondition.createTimeArry &&
        this.searchCondition.createTimeArry.length > 0
          ? this.searchCondition.createTimeArry[1]
          : null;

      Object.assign(params, searchCondition);
      const { code, result } = await this.$store.dispatch(
        "queryRepurchasePlanExecRecordList",
        params
      );
      if (code === "0") {
        const { total, records } = result;
        this.list = records;
        this.total = total;
      }
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    }
  }
};
</script>
<style lang='scss' scoped>
.purchase-data {
  background: #fff;
  box-shadow: 0px 0px 18px 0px rgba(221, 221, 221, 0.39);
  border-radius: 6px;
  .hm-icon {
    width: 66px;
    height: 66px;
    border-radius: 50%;
    text-align: center;
    line-height: 66px;
    background: #feeef5;
    .hmicon {
      font-size: 25px;
      color: #e50065;
    }
  }
  .purchase-name {
    color: #222222;
    font-size: 14px;
  }
  .purchase-val {
    font-size: 24px;
    font-weight: bold;
  }
}
</style>
